export default __webpack_public_path__ + "static/media/devLogo.ccc31442.png";